import Cookies from 'js-cookie';
import { v4 } from 'uuid';

import { userApiRequests } from './api-requests/user';
import { Platform, usePlatform } from './hooks/usePlatform';

export const decodeJwtToken = (token?: string) => {
    const platform = usePlatform();
    let currentToken = token || Cookies.get('MonitorApiToken');

    if (!currentToken && (platform === Platform.IOS || platform === Platform.Android)) {
        currentToken = localStorage.getItem('MonitorApiToken') || undefined;
    }

    if (!currentToken) {
        return null;
    }

    try {
        const parts = currentToken.split('.');

        if (parts.length !== 3) {
            return null;
        }

        const payload = parts[1];

        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = atob(base64);

        return JSON.parse(jsonPayload);
    } catch (error) {
        const errorId = v4();

        if (error instanceof Error) {
            userApiRequests.logException(error, errorId);
        }

        return null;
    }
};
